import { notFound } from '@tanstack/react-router';

import { isApiError } from '@@api/errorHandler';
import { HTTP_STATUS_CODES } from '@@constants/http';

/**
 * Rethrows a loader's failed request for the router: an API 404 as `notFound()`, which shows the
 * 404 page, and any other error as it is, which shows the error page.
 */
export const handleLoaderError = (error: unknown): never => {
    throw isApiError(error) && error.status === HTTP_STATUS_CODES.NOT_FOUND ? notFound() : error;
};
